import _ from 'lodash';
import {
  Accordion,
  Card,
} from 'react-bootstrap';
import Navigation from './Step.Navigation';
import StepStatus from './Step.Status';

const Step = (props) => {
  const {
    handleActiveStep, handleLogout, handleOnFinish, Status, handleStepResults, Content, stepResults, index, isValid, result,
  } = props;
  const controlProps = _.merge({}, {
    isStepValid: isValid(result),
  }, _.pick(props, [
    'active',
    'completed',
    'index',
    'last',
    'pending',
    'result',
    'title',
  ]));

  const setCurrentStepResult = (result) => {
    handleStepResults(result, props.index);
  };

  return (
    <Card className="stepper__step--vertical" bsPrefix>
      <StepStatus {...controlProps}>
        <Status {...controlProps} handleActiveStep={handleActiveStep} />
      </StepStatus>
      <Accordion.Collapse eventKey={`${index}`}>
        <Card.Body className="stepper__step-body">
          <Content setCurrentStepResult={setCurrentStepResult} stepResults={stepResults} handleLogout={handleLogout} {...controlProps} />
          <Navigation
            {...controlProps}
            handleActiveStep={handleActiveStep}
            handleLogout={handleLogout}
            handleOnFinish={handleOnFinish}
          />
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default Step;
